import React, { useEffect, useState } from 'react';
import { SelectField } from '../../../components/form/select-field';
import { getManagers } from '../requests/get-managers';

const mapToOptions = (managers = []) =>
  managers.map(({ id, name }) => ({
    label: name,
    value: id,
  }));

export function ManagerField() {
  const [loading, setLoading] = useState(false);
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    setLoading(true);
    getManagers()
      .then((res) => {
        setManagers(mapToOptions(res.data));
      })
      .catch(() => {
        return null;
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <SelectField loading={loading} name="manager" options={managers} />
  );
}
